import request from './index'

// 获取推送列表
export function getList(params) {
  return request({
    url: '/pushes',
    method: 'get',
    params
  })
}

// 新增推送
export function save(data) {
  return request({
    url: '/pushes/save',
    method: 'post',
    data
  })
}

// 获取用户列表（推送目标选择）
export function getUsers() {
  return request({
    url: '/pushes/users',
    method: 'get'
  })
}

// 获取内容列表（推送内容选择）
export function getContents() {
  return request({
    url: '/pushes/contents',
    method: 'get'
  })
}
